export default {

	namespaced: true,

	state: {
		overlayNavActive: false,
		activeVideoModal: false,
		embedMode: false
	},

	mutations: {
		toggleOverlayNav (state, payload) {
			if(payload === undefined) {
				payload = !state.overlayNavActive
			}
			state.overlayNavActive = payload
		},
		setActiveVideoModal (state, payload) {
			state.activeVideoModal = (() => {
				if(!payload) {
					return false
				}
				if(typeof payload === 'string') {
					return { src: payload }
				} else {
					return payload
				}
			})()
		}
	}

}



// WEBPACK FOOTER //
// ./src/store/modules/app.js